import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/vue `cn` helper — merges Tailwind classes safely. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
